// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_City = require("../../../../shared/src/types/CommonTypes_City.bs.js");
var WebGraphql_Signup = require("../../graphql/WebGraphql_Signup.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebContainers_Signup_Professional_Success = require("./WebContainers_Signup_Professional_Success.bs.js");
var WebContainers_Signup_Professional_VerifyCode = require("./WebContainers_Signup_Professional_VerifyCode.bs.js");
var WebContainers_Signup_Professional_PersonalInfo = require("./WebContainers_Signup_Professional_PersonalInfo.bs.js");

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexDirection(BrowserStyle.row),
          tl: {
            hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
            tl: {
              hd: BrowserStyle.minHeight(BrowserStyle.vh(100.0)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* White */7,
            _0: /* Light */2
          }),
      tl: {
        hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
        tl: {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: {
            hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
            tl: {
              hd: BrowserStyle.minWidth(BrowserStyle.rem(34.0)),
              tl: {
                hd: BrowserStyle.mobileMedia({
                      hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                      tl: {
                        hd: BrowserStyle.minWidth(BrowserStyle.zero),
                        tl: /* [] */0
                      }
                    }),
                tl: {
                  hd: BrowserStyle.overflowY("scroll"),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var imageContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundImage(BrowserStyle.url(BrowserStyle.$$Image.heroProfessional)),
      tl: {
        hd: BrowserStyle.backgroundRepeat("noRepeat"),
        tl: {
          hd: BrowserStyle.backgroundSize("cover"),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 2.0
                }),
            tl: {
              hd: BrowserStyle.flexBasis(BrowserStyle.pct(60.0)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  wrapper: wrapper,
  content: content,
  imageContainer: imageContainer
};

function WebContainers_Signup_Professional$Presentation(Props) {
  var checkIfEmailIsAvailable = Props.checkIfEmailIsAvailable;
  var checkIfPhoneNumberIsAvailable = Props.checkIfPhoneNumberIsAvailable;
  var cities = Props.cities;
  var layout = Props.layout;
  var view = Props.view;
  var tmp;
  tmp = typeof view === "number" ? React.createElement(WebContainers_Signup_Professional_Success.make, {}) : (
      view.TAG === /* PersonalInfo */0 ? React.createElement(WebContainers_Signup_Professional_PersonalInfo.make, {
              checkIfEmailIsAvailable: checkIfEmailIsAvailable,
              checkIfPhoneNumberIsAvailable: checkIfPhoneNumberIsAvailable,
              cities: cities,
              initialReferralCode: view.maybeReferralCode,
              utmParams: view.utmParams
            }) : React.createElement(WebContainers_Signup_Professional_VerifyCode.make, {
              city: view.city,
              email: view.email,
              firstName: view.firstName,
              lastName: view.lastName,
              phoneNumber: view.phoneNumber,
              referralCode: view.referralCode,
              utmParams: view.utmParams,
              zipcode: view.zipcode
            })
    );
  return React.createElement("main", {
              className: wrapper
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: content,
                  children: null
                }, React.createElement(BrowserComponents_Image.make, {
                      image: {
                        TAG: /* Logo */2,
                        _0: /* Dark */4
                      }
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), tmp), layout >= 2 ? React.createElement("div", {
                    className: imageContainer
                  }) : null);
}

var Presentation = {
  Styles: Styles,
  make: WebContainers_Signup_Professional$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, (function (param) {
        return param.cities;
      }), WebStore_Selectors.getApolloClient, (function (param) {
        return param.layout;
      }), (function (cities, client, layout) {
        return {
                cities: Relude_Option.fold([], (function (param) {
                        return Relude_Globals.$great$great(Relude_Set.toArray, (function (param) {
                                      return Relude_Array.sortBy(CommonTypes_City.compareByName, param);
                                    }), param);
                      }), Relude_AsyncResult.getOk(cities)),
                client: client,
                layout: layout
              };
      }));

function mapDispatchToProps(_dispatch, param) {
  var client = param.client;
  return {
          checkIfEmailIsAvailable: (function (email) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._2(WebGraphql_Signup.CheckEmailAvailable.query, email, client));
            }),
          checkIfPhoneNumberIsAvailable: (function (phoneNumber) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._2(WebGraphql_Signup.CheckPhoneNumberAvailable.query, phoneNumber, client));
            })
        };
}

function WebContainers_Signup_Professional(Props) {
  var view = Props.view;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Signup_Professional$Presentation, {
                              checkIfEmailIsAvailable: param$1.checkIfEmailIsAvailable,
                              checkIfPhoneNumberIsAvailable: param$1.checkIfPhoneNumberIsAvailable,
                              cities: param.cities,
                              layout: param.layout,
                              view: view
                            });
                })
            });
}

var make = WebContainers_Signup_Professional;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* wrapper Not a pure module */
